import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export default function KineticLines({
  lines,
  as: Tag = "h1",
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.13,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
